























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component
export default class Dialog extends Vue {
  // 是否展示
  @Prop({ default: false }) visible!: boolean;
  // 是否需要遮罩层
  @Prop({ default: true }) modal!: boolean;
  // 遮罩层是否插入到body上
  @Prop({ default: true }) modalAppendToBody!: boolean;
  // dialog是否插入到body上
  @Prop({ default: true }) appendToBody!: boolean;
  // dialog宽度
  @Prop() width!: string;
  // dialog高度
  @Prop() height!: string;
  // dialog是否全屏
  @Prop() fullscreen!: boolean;

  @Watch('visible')
  onVisibleChange(val) {
    // 展示页面
    if (val) {
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  }

  mounted() {
    if (this.visible) {
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  }

  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }

  // 点击关闭按钮抛出关闭事件，在父组件中做处理
  handleCloseClick() {
    this.$emit('closeDialog');
  }

  // 点击弹窗外部分关闭弹窗
  handleContainerClick(event) {
    const dialog = document.getElementById('dialog-body');
    if (dialog && this.visible === true) {
      if (!dialog.contains(event.target)) {
        this.$emit('closeDialog');
      }
    }
  }
  // 弹窗内容宽高样式
  get style() {
    const style: any = {};
    if (this.width) {
      style.width = this.width;
    }
    if (this.height) {
      style.height = this.height;
    }
    return style;
  }
}
